export const siteConfig = {
  name: '蜜桃视频',
  tagline: '发现精彩，分享快乐',
  description: '蜜桃视频是一个高品质在线视频内容平台，汇聚海量优质视频资源，涵盖影视娱乐、知识科普、生活时尚、音乐舞蹈等多种内容分类。我们致力于为用户提供流畅、高清的视频观看体验。',
  url: 'https://www.mitaovideo.com',
  contactEmail: 'contact@mitaovideo.com',
  customerService: '400-888-6666',
  address: '北京市朝阳区望京科技园A座18层',
  copyright: '© 2026 蜜桃视频 版权所有',
  socialLinks: {
    weibo: 'https://weibo.com/mitaovideo',
    wechat: 'mitaovideo',
    bilibili: 'https://space.bilibili.com/mitaovideo',
    douyin: 'https://www.douyin.com/user/mitaovideo',
  },
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '内容分类', path: '/category/variety' },
  { label: '使用教程', path: '/#tutorial' },
  { label: '常见问题', path: '/#faq' },
  { label: '关于我们', path: '/about' },
];

export const heroSlides = [
  {
    title: '蜜桃视频 · 全新体验',
    subtitle: '海量优质内容，随时随地畅享高清视频',
    cta: '立即体验',
    ctaLink: '/category/variety',
  },
  {
    title: '多元内容 · 精彩纷呈',
    subtitle: '影视、综艺、知识、音乐，总有一款适合你',
    cta: '探索内容',
    ctaLink: '/category/variety',
  },
  {
    title: '高清流畅 · 极致观影',
    subtitle: '4K超清画质，智能推荐，为你量身定制',
    cta: '了解更多',
    ctaLink: '/#features',
  },
];

export const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持4K超高清分辨率播放，带来身临其境的视觉享受，每一帧都清晰细腻。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '手机、平板、电脑无缝切换，观看记录云端同步，随时随地继续观看。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能推荐',
    description: '基于AI算法的个性化推荐系统，根据你的喜好精准推送你可能感兴趣的内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '严格的内容审核机制，保护用户隐私安全，提供健康绿色的视频观看环境。',
  },
  {
    icon: 'ri-download-2-line',
    title: '离线下载',
    description: '支持视频离线缓存，无网络也能畅享精彩内容，通勤路上不再无聊。',
  },
  {
    icon: 'ri-user-star-line',
    title: '创作者扶持',
    description: '为优质创作者提供流量支持和变现渠道，打造繁荣的内容创作生态。',
  },
];

export const stats = [
  { value: '5000万+', label: '月活跃用户' },
  { value: '100万+', label: '优质创作者' },
  { value: '200万+', label: '视频内容库' },
  { value: '99.9%', label: '服务可用率' },
];